import React from 'react'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import { Field } from 'react-final-form'

import TextField from '@ui/Fields/TextField'
import Select from '@ui/Fields/Select'
import TelephoneField from '@ui/Fields/Telephone'
import styles from '@theme/styles/forms'
import { languages, positions } from '@models/admin/organizationContacts'

const Form = ({
  handleSubmit,
  classes,
  title,
  organization,
  o
}) =>
  <form className={classes.form} onSubmit={handleSubmit} data-testid='contacts-form'>
    <Paper className={classes.form__wrapper} elevation={0}>
      <header className={classes.form__header}>
        <Typography component='h2' variant='h5'>
          {title}
        </Typography>
      </header>

      <main className={classes.form__fields}>
        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            fullWidth
            InputLabelProps={{ shrink: true }}
            label={I18n.t('activerecord.attributes.v4/organization_contact.name')}
            margin='normal'
            name='name'
            variant='outlined'
            required
          />
        </div>

        <div className={classes.form__field__wrapper}>
          <Field
            component={Select}
            className={classes.form__fieldWithError}
            fullWidth
            InputLabelProps={{ shrink: true }}
            label={I18n.t('activerecord.attributes.v4/organization_contact.position')}
            margin='normal'
            name='position'
            variant='outlined'
            fields={{ id: 'id', name: 'name' }}
            data={positions()}
            allowEmpty
          />
        </div>

        <div className={classes.form__field__wrapper}>
          <Field
            component={Select}
            className={classes.form__fieldWithError}
            fullWidth
            InputLabelProps={{ shrink: true }}
            label={I18n.t('activerecord.attributes.v4/organization_contact.language')}
            margin='normal'
            name='language'
            variant='outlined'
            fields={{ id: 'id', name: 'name' }}
            data={languages()}
            allowEmpty
          />
        </div>

        <div className={classes.form__field__wrapper}>
          <Field
            component={TextField}
            className={classes.form__fieldWithError}
            fullWidth
            InputLabelProps={{ shrink: true }}
            label={I18n.t('activerecord.attributes.v4/organization_contact.email')}
            margin='normal'
            name='email'
            type='email'
            variant='outlined'
          />
        </div>

        <div className={classes.form__field__wrapper}>
        <Field
            component={TelephoneField}
            className={classes.form__fieldWithError}
            fullWidth
            InputLabelProps={{ shrink: true }}
            label={I18n.t('activerecord.attributes.v4/organization_contact.phone_number')}
            margin='normal'
            name='phone_number'
            variant='outlined'
            placeholder='11 99999-0001'
          />
        </div>
      </main>

      <footer className={classes.form__actions}>
        <Button
          className={classes.form__action}
          color='primary'
          type='submit'
          variant='contained'
        >
          {title}
        </Button>

        <Button
          className={classes.form__action}
          color='secondary'
          href={`/v4/o/${o}/admin/organizations/${organization.id}/contacts`}
        >
          {I18n.t('actions.back')}
        </Button>
      </footer>
    </Paper>
  </form>

export default withStyles(styles)(Form)
